module.exports = __webpack_public_path__ + "static/gw-admin-01-c4badead19e3ed4be4b48583ea7e1bf7.png";